import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Education } from './components/Education';
import { Process } from './components/Process';
import { Services } from './components/Services';
import { Issues } from './components/Issues';
import { Testimonials } from './components/Testimonials';
import { CTA } from './components/CTA';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <main className="w-full min-h-screen bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <Hero data-id="element-2" />
      <div id="about" data-id="element-3">
        <About data-id="element-4" />
      </div>
      <Issues data-id="element-5" />
      <CTA data-id="element-6" />
      <div id="testimonials" data-id="element-7">
        <Testimonials data-id="element-8" />
      </div>
      <Process data-id="element-9" />
      <div id="education" data-id="element-10">
        <Education data-id="element-11" />
      </div>
      <div id="services" data-id="element-12">
        <Services data-id="element-13" />
      </div>
      <div id="contact" data-id="element-14">
        <Contact data-id="element-15" />
      </div>
      <FAQ data-id="element-16" />
      <Footer data-id="element-17" />
    </main>;
}